import ReactDOM from "react-dom/client";
import React from "react";

export function DefineWebComponent(name: string, component: React.JSX.Element, props:any = {}) {
  if (!window.customElements.get(name)) {
    window.customElements.define(name, class extends HTMLElement {
      connectedCallback() {
        ReactDOM.createRoot(this).render(component)
      }
    })
  }
}